module.exports = __webpack_public_path__ + "img/img-sicbo.e6abb546.png";